import { AgencyWaitlistDialog } from "@/components/AgencyWaitlistDialog";
import { HeroBrainVisual } from "@/components/HeroBrainVisual";
import { useI18n } from "@/lib/i18n";

export function AgencyHero() {
  const { t } = useI18n();
  return (
    <section className="relative overflow-hidden pt-20 pb-24" style={{ backgroundColor: "#0a1845" }}>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 20%, rgba(232,114,26,0.12), transparent 60%)",
        }}
      />
      <div className="absolute -bottom-32 -left-32 w-[32rem] h-[32rem] rounded-full bg-primary/20 blur-[140px] pointer-events-none" />
      <div className="absolute top-1/4 -right-32 w-96 h-96 rounded-full bg-primary/10 blur-[120px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Left: copy + CTAs */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-border bg-card/50 text-xs font-medium text-muted-foreground mb-8">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              {t("agency.hero.badge")}
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05] mb-6 text-white">
              {t("agency.hero.title1")}
              <br />
              <span style={{ color: "#e8721a" }}>{t("agency.hero.title2")}</span>
            </h1>
            <p className="text-base md:text-lg max-w-2xl mx-auto lg:mx-0 mb-10 leading-relaxed" style={{ color: "#94a3b8" }}>
              {t("agency.hero.desc")}
            </p>

            <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-4">
              <AgencyWaitlistDialog>
                <button
                  style={{ backgroundColor: "#e8721a", boxShadow: "0 0 40px rgba(232,114,26,0.55)" }}
                  className="inline-flex items-center justify-center rounded-full px-8 py-3.5 text-base font-semibold text-white hover:brightness-110 transition w-full sm:w-auto"
                >
                  {t("agency.hero.joinWaitlist")}
                </button>
              </AgencyWaitlistDialog>
              <a
                href="#agency-pricing"
                className="inline-flex items-center justify-center rounded-full border border-white/30 bg-transparent px-8 py-3.5 text-base font-semibold text-white hover:bg-white/5 transition w-full sm:w-auto"
              >
                {t("agency.hero.seePricing")}
              </a>
            </div>
          </div>

          {/* Right: dashboard/phone visual reused from homepage hero */}
          <div className="relative">
            <HeroBrainVisual />
          </div>
        </div>
      </div>
    </section>
  );
}
